import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import PublicHeader from "@/components/layout/PublicHeader";
import PublicFooter from "@/components/layout/PublicFooter";
import { SetupPackages, AddOns, BuyerPricing } from "@/components/marketing/MarketingSections";

export default function Packages() {
  const { hash } = useLocation();
  useEffect(() => {
    if (!hash) return;
    const id = hash.slice(1);
    // Wait a tick for sections to mount before scrolling
    const t = setTimeout(() => {
      const el = document.getElementById(id);
      if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    }, 120);
    return () => clearTimeout(t);
  }, [hash]);

  return (
    <div data-testid="packages-page" className="min-h-screen bg-background">
      <PublicHeader />
      <SetupPackages />
      <AddOns />
      <BuyerPricing />
      <PublicFooter />
    </div>
  );
}
